import React, { useState } from 'react';
import Modal from 'react-modal';
import { XMarkIcon } from "@heroicons/react/24/solid";
import { motion, AnimatePresence } from "framer-motion";

type VideoModalProps = {
    isOpen: boolean;
    videoUrl: string;
    onClose: () => void;
};

const VideoModal: React.FC<VideoModalProps> = ({ isOpen, videoUrl, onClose }) => {
    // Define animation variants for fading in/out
    const modalVariants = {
        hidden: { opacity: 0 },
        visible: { opacity: 1 },
    };

    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    initial={{ scaleX: 1 }}
                    animate={{ scaleX:0, transition: { duration: 1.5, ease: "circOut" } }}
                    exit={{ scaleX: 1, transition: { duration: 1.5, ease: "circIn" } }}
                    variants={modalVariants}
                    transition={{ duration: 1 }}
                >
                    <Modal
                        isOpen={true}
                        onRequestClose={onClose}
                        className="video-modal" // You can style the modal here
                        overlayClassName="modal-overlay" // You can style the modal overlay here
                        style={{
                            overlay: {
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                background: 'rgba(0, 0, 0, 0.7)', // Adjust the background color and opacity
                                zIndex: 1000, // Adjust the z-index to appear on top
                            },
                            content: {
                                position: 'absolute',
                                top: '50%', // Vertically center the modal
                                left: '50%', // Horizontally center the modal
                                transform: 'translate(-50%, -50%)', // Center the modal using a translate transform
                                border: 'none',
                                background: 'none',
                                overflow: 'visible', // Allow the modal to overflow if needed
                            },
                        }}
                    >
                        <div className="video-container relative">
                            <div>
                                <div
                                    className="cursor-pointer transition-transform duration-1000 transform hover:rotate-90"
                                    style={{
                                        width: '32px', // Adjust the width
                                        height: '32px', // Adjust the height
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                    onClick={onClose}
                                >
                                    <XMarkIcon className="w-8 text-color-dark" aria-hidden="true" />
                                </div>
                            </div>

                            <video autoPlay controls>
                                <source src={videoUrl} type="video/mp4" />
                            </video>
                        </div>
                    </Modal>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default VideoModal;
